import script from "./PwaInstallBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./PwaInstallBanner.vue?vue&type=script&setup=true&lang=ts"

import "./PwaInstallBanner.vue?vue&type=style&index=0&id=38bdf172&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38bdf172"]])

export default __exports__